import React, { useState, useEffect } from 'react';

// material-ui
import { Tabs, Tab } from '@mui/material';

// project imports
import { Link } from 'react-router-dom';

const MatchesTabs = ({ tab, handleMainTabChange, tabOptions }) => {
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`
        };
    }

    return (
        <Tabs
            value={tab}
            onChange={handleMainTabChange}
            variant="scrollable"
            sx={{
                // marginTop: 2.5,
                '& .MuiTabs-flexContainer': {
                    border: 'none'
                },
                '& a': {
                    minHeight: 'auto',
                    minWidth: 10,
                    py: 1.5,
                    px: 1,
                    mr: 2.25,
                    color: 'grey.700',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                '& a.Mui-selected': {
                    color: 'primary.main'
                },
                '& a > svg': {
                    marginBottom: '4px !important',
                    mr: 1.25
                }
            }}
        >
            {tabOptions.map((option, index) => (
                <Tab
                    key={index}
                    component={Link}
                    // to={option.to}
                    // icon={option.icon}
                    label={option}
                    {...a11yProps(index)}
                />
            ))}
        </Tabs>
    );
};

export default MatchesTabs;
